module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var constants = require('Constants.js').default;

    ; __append("\r\n\r\n<div class=\"page-title\">\r\n    <div class=\"row\">\r\n        <div class=\"col col-sm-12\">\r\n            <h1>")
    ; __append(escapeFn( dashboardTitle ))
    ; __append("</h1>\r\n        </div>\r\n    </div>\r\n\r\n    <ol class=\"breadcrumb\">\r\n        ")
    ; 
        var count = breadcrumbs.length;
        var crumbCount = 0;
        _.forEach(breadcrumbs, function (crumb) {
            crumbCount++;
            if (crumbCount === count) {
            
    ; __append("\r\n            <li><span class=\"active\">")
    ; __append(escapeFn( crumb.name ))
    ; __append("</span></li>\r\n            ")
    ;  } else { 
    ; __append("\r\n            <li><a href=\"")
    ; __append(escapeFn( crumb.route ))
    ; __append("\" id=\"")
    ; __append(escapeFn( crumb.id ))
    ; __append("\">")
    ; __append(escapeFn( crumb.name ))
    ; __append("</a></li>\r\n            ")
    ; 
            }
        });
    ; __append("\r\n    </ol>\r\n</div>\r\n<div class=\"row\">\r\n   \r\n    <div class=\"col-md-4\">\r\n        <div class=\"row\"><h2>General</h2></div>\r\n        <div class=\"row\">\r\n        \r\n            <div class=\"col-md-5\" style=\"font-weight: bold;\">Package Name</div>\r\n            <div class=\"col-md-7\">")
    ; __append(escapeFn( accountSettings.PackageType ))
    ; __append("</div>\r\n        </div>\r\n        <div class=\"row\">\r\n            <div class=\"col-md-5\" style=\"font-weight: bold;\">Expiry Date</div>\r\n            <div class=\"col-md-7\">")
    ; __append(escapeFn( accountSettings.ExpiryDate ))
    ; __append("</div>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-8\">\r\n        <div class=\"row\">\r\n            <h2>Limits</h2>\r\n        </div>\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n                <table id=\"propMainTable\"></table>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<br />\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n        <div class=\"row\">\r\n            <h2>Settings Help</h2>\r\n        </div>\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12\"><a href=\"")
    ; __append(escapeFn(constants.HELP_LICENSE_INFO ))
    ; __append("\" target=\"_blank\">License Information</a></div>\r\n        </div>\r\n    </div>    \r\n</div>\r\n\r\n<div class=\"row actionButtons\">\r\n    <div class=\"col-md-12\">\r\n        <button class=\"btn btn-default\" type=\"button\" id=\"sRefresh\">Refresh Storage</button>\r\n    </div>\r\n</div>")
  }
  return __output;

}